<script setup>

import ClCommentsSlider from '@/components/home/ClCommentsSlider.vue'
</script>

<template>
  <v-container tag="section" >
    <v-row>
      <v-col cols="12" class="d-flex flex-column align-center justify-center text-center">
        <h1 class="font-weight-bold cl-section__title" :class="[!$vuetify.display.mdAndDown ? 'mb-10' : '']">دانش‌آموزها و والدین راجع به کلاسینو چی میگن؟!</h1>
        <p class="cl__section__subtitle">
          دانش‌آموزهای زیادی با کلاسینو به هدفشون رسیدن و اینجا موفقیت‌های خودشون رو با ما به اشتراک می‌ذارن. اگه هنوز مطمئن نیستی نظرات واقعی بچه‌ها و خانواده‌شون رو ببین و با اطمینان بیشتر تصمیم بگیر.
        </p>
      </v-col>
    </v-row>
    <ClCommentsSlider></ClCommentsSlider>
  </v-container>
</template>

<style scoped lang="scss">

</style>
